<template>
  <div class='main'>
    <div class='menuContainer' :style="`width:${isHidden?'0':'221px'}`">
      <div class='hiddenIcon' @click='hiddenTab'>
        <i :class="isHidden?'el-icon-caret-right':'el-icon-caret-left'" style='color:#fff'/>
      </div>
      <el-menu
        :default-active='pathActive'
        text-color='#335483'
        active-text-color='#fff'
        :unique-opened='true'
        style='width: 221px'
        :style="`transform:translateX(${isHidden?'-221px':'0'});transition: all .3s;`"
        @select='selectMenu'
        router
      >
        <el-submenu index='/basicfile/branch' v-has="'pc_system_user_manage'">
          <template slot='title'>
            <i class='el-icon-user-solid' style='color:#335483'/>
            <span>系统用户管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/branch' v-has="'pc_company_manage'">分公司管理
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/department' v-has="'pc_department_manage'">部门管理
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/role' v-has="'pc_role_manage'">pc角色管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/appRole' v-has="'pc_role_manage'">app角色管理
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/user' v-has="'pc_user_manage'">用户管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/basicfile/company' v-has="'pc_customer'">
          <template slot='title' v-has="'pc_customer_1'">
            <i class='el-icon-s-management' style='color:#335483'/>
            <span>委托商档案</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/company' v-has="'pc_customer_manage'">委托商管理
            </el-menu-item>
            <el-menu-item index='/basicfile/type' v-has="'pc_customer_type'">委托商类型
            </el-menu-item>
            <!-- <el-menu-item index="/basicfile/consignorWarehouse" v-has="'pc_customer_store'">委托商仓库管理</el-menu-item> -->
            <el-menu-item index='/basicfile/carModel' v-has="'pc_entrust_model'">委托车车型
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/basicfile/team' v-has="'pc_supplier'">
          <template slot='title' v-has="'pc_supplier_1'">
            <i class='el-icon-s-ticket' style='color:#335483'/>
            <span>供应商档案</span>
          </template>
          <el-menu-item-group v-if="false">
            <el-menu-item index='/basicfile/supplier'>供应商管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_highway'">
            <el-menu-item index='/basicfile/team'>公路供应商</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_highway_driver'">
            <el-menu-item index='/basicfile/driver'>司机管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_highway_car'">
            <el-menu-item index='/basicfile/truck'>运输车管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_waterway'">
            <el-menu-item index='/basicfile/water'>水路供应商</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_waterway_ship'">
            <el-menu-item index='/basicfile/ship'>船舶管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_port'">
            <el-menu-item index='/basicfile/port'>港口及其它</el-menu-item>
          </el-menu-item-group>
          <!--修改权限-->
          <el-menu-item-group v-has="'pc_supplier_port'">
            <el-menu-item index='/basicfile/supplierManagement'>供应商管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/basicfile/Distribution' v-has="'pc_distributor'">
          <template slot='title' v-has="'pc_distributor_1'">
            <i class='el-icon-s-ticket' style='color:#335483'/>
            <span>经销商档案</span>
          </template>
          <el-menu-item-group v-has="'pc_distributor_manage'">
            <el-menu-item index='/basicfile/distributor'>经销商管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/basicfile/adress' v-has="'pc_address'">
          <template slot='title' v-has="'pc_address_1'">
            <i class='el-icon-location' style='color:#335483'/>
            <span>地址档案</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/adress' v-has="'pc_address_manage'">地址管理
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/area' v-has="'pc_address_manage'">区域管理
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/basicfile/harbor' v-has="'pc_address_manage'">港口管理
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_warehouse_manage'">
            <el-menu-item index='/basicfile/consignorWarehouseNew'>
              库房管理
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu v-has="'pc_dictionaries_manage'" index='/basicfile/dictionariesAd'>
          <template slot='title'>
            <i class='el-icon-s-tools' style='color:#335483'/>
            <span>字典管理</span>
          </template>
          <el-menu-item-group v-has="'pc_dictionaries_info'">
            <el-menu-item index='/basicfile/dictionariesAd'>字典管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class='content2' :style="`width:${isHidden?'100%':'calc(100% - 221px)'}`"
         style='background-color: rgb(244, 247, 251);'>
      <router-view v-if="$route.path.split('/').length>=3"
                   style='background-color: rgb(244, 247, 251);min-height: calc(100% - 60px)'/>
      <Home v-else style='min-height: calc(100% - 60px)'/>
      <div class='footer-div'>渝ICP备2022002327号-1</div>
      <!-- <div class="footer">
        <div style="min-width: 300px;color: #677788;text-align: center;">版权所有@ 民生整车</div>
      </div> -->
    </div>

  </div>
</template>

<script>
import Home from '@/views/home/main';

export default {
  components: {
    Home,
  },

  data() {
    return {
      pathActive: null,
      activeNum: 1,
      isHidden: false,
    };
  },
  watch: {
    $route(to, from) {
      this.pathActive = this.$route.path;
    },
  },
  mounted() {
    this.pathActive = this.$route.path;
  },
  methods: {
    hiddenTab() {
      this.isHidden = !this.isHidden;
    },
    selectMenu() {
      this.activeNum = 0;
    },
  },
};
</script>


<style lang='scss' scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;

  .menuContainer {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: relative;
    transition: all .3s;
    height: calc(100vh - 70px);
    overflow-x: hidden;

    .hiddenIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #48599E;
      width: 11px;
      height: 50px;
      position: absolute;
      top: calc(50% - 20px);
      right: -11px;
      border-radius: 0 10px 10px 0;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .content {
    width: calc(100% - 221px);
    height: calc(100vh - 70px);
    overflow: auto;
  }

  .content2 {
    transition: all .3s;
    width: 100%;
    height: calc(100vh - 70px);
    overflow: auto;

    .footer {
      width: 100%;
      background-color: white;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      /*position: fixed;*/
      /*z-index: 99999;*/
    }
  }

  ::v-deep {
    .el-menu-item.is-active {
      background-color: #335483;
    }

    .el-menu-item:focus {
      outline: 0;
      background-color: #335483;
    }
  }

  .content2 > .contract-list, .content2 > .electrify,
  .content2 > .operation, .content2 > .consignSettle,
  .content2 > .portSettle, .content2 > .stockpile,
  .content2 > .warehouse, .content2 > .deferlnvoicing,
  .content2 > .massLoss-list, .content2 > .logisticsConfig,
  .content2 > .finance-income, .content2 > .price-highway,
  .content2 > .main, .content2 > .supplierTrain,
  .content2 > .otherFees, .content2 > .mainContainer,
  .content2 > .carModel, .content2 > .price-Review,
  .content2 > .contract-type, .content2 > .consignor-daily,
  .content2 > .consignor-train {
    height: calc(100% - 30px);
    overflow-y: auto;
  }

  .footer-div {
    display: block;
    position: relative;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 30px;
    font-size: 13px;
    line-height: 30px;
    text-align: center;
    color: #a8a8a8;
    background-color: #f4f7fb;
  }
}
</style>
